/**
 * @desc 保存操作日志
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: defs.aider.SaveOperationParamDto, options?: any) {
  return updateResponse(
    http(URL + `/log/operation/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
